import { ComponentPropsWithoutRef, ReactNode, } from 'react';
import { classNames } from '../common/utils/utils';
import LoadingContent from './LoadingContent';

interface ButtonProps extends ComponentPropsWithoutRef<'button'> {
  label: string;
  icon?: ReactNode;
  loading?: boolean;
  diasbled?: boolean;
}

const Button = ({ label, icon, loading, disabled, ...rest }: ButtonProps) => {
  return (
    <button {...rest} aria-label={label} disabled={disabled ? disabled : loading ? true : false}>
      {icon}
      <div
        className={classNames(
          label ? 'sm:block' : '',
          icon ? 'hidden' : '',
          loading ? 'flex justify-items' : '',
        )}
      >
        {loading ? <LoadingContent /> : label}
      </div>
    </button>
  );
};

export default Button;
